import { Helmet } from "react-helmet-async";

const SITE = "سياق";
const BASE = "https://siaq-sa.com";

export default function Seo({ title, description, path = "/", type = "website", jsonLd }) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} للاستشارات | لسياقك نبتكر`;
  const url = `${BASE}${path}`;
  return (
    <Helmet>
      <html lang="ar" dir="rtl" />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:site_name" content="سياق للاستشارات" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="ar_SA" />
      <meta name="twitter:card" content="summary_large_image" />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "سياق للاستشارات وحلول تمكين القدرات",
  url: BASE,
  email: "info@siaq-sa.com",
  sameAs: [
    "https://instagram.com/siaqsa1",
    "https://twitter.com/siaqsa1",
  ],
};
